import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot } from '@angular/router';
import { IReject, IResolve } from '@df/api/request/request.service';
import { NSearch } from '@df/search/df-search.config';
import { AdvancedCommerceConfigStore } from '../store/advanced-commerce-config.store';
import { AdvancedCommerceSearchResult } from './advanced-commerce-search-result';
import { AdvancedCommerceSearchService } from './advanced-commerce-search.service';

@Injectable({
    providedIn: 'root'
})
export class AdvancedCommerceSearchResolver {
    protected configStore = inject(AdvancedCommerceConfigStore);
    protected router = inject(Router);
    protected advancedCommerceSearchService = inject(AdvancedCommerceSearchService);
    protected config = inject(NSearch.OPTIONS);

    /**
     * Resolve method
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AdvancedCommerceSearchResult> {
        return new Promise((resolve: IResolve, reject: IReject) => {
            const term = this.getTerm(route);

            this.configStore.loadConfig().then(() => {
                this.getSearch(term, route.queryParams)
                    .then(result => {
                        const redirect = result.data?.redirect;
                        const queryParams = result.data?.queryParams;

                        if (redirect) {
                            if (redirect.match(/https?:\/\//)) {
                                window.location.href = redirect;
                            } else {
                                this.router.navigate([redirect], { queryParams, state: { redirect: true } });
                            }
                        } else {
                            resolve(result);
                        }
                    })
                    .catch(reject);
            });
        });
    }

    getTerm(route: ActivatedRouteSnapshot): string {
        const url = route.url.map(u => u.path).join('/');

        return decodeURIComponent(url);
    }

    getSearch(term: string, queryParams: Params): Promise<AdvancedCommerceSearchResult> {
        return this.advancedCommerceSearchService.search({
            q: term,
            resolver: true,
            queryParams,
            ...this.config.options.view
        });
    }
}
